export default "__VITE_ASSET__A12BDFtj__"